import React from 'react';

function TarjetaPaciente({ paciente, activo, onSeleccionar }) {
  const ciudadCampo = paciente.camposExtra?.find((c) => c.id === 'city');
  const edad = paciente.edad;
  const infoExtra = [edad !== null && edad !== undefined && `${edad} años`, ciudadCampo?.value].filter(Boolean).join(' · ');
  const inactivo = paciente.is_active === false;

  return (
    <div
      className={`tab ${activo ? 'active' : ''} ${inactivo ? 'tab-inactivo' : ''}`}
      onClick={() => onSeleccionar(paciente.id)}
    >
      <div className="tab-nombre">
        {paciente.nombre}
        {inactivo && <span className="tab-badge-inactivo">Inactivo</span>}
      </div>
      {infoExtra && <div className="tab-info">{infoExtra}</div>}
    </div>
  );
}

export default TarjetaPaciente;
